import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class Admin_Dashboard_Upcomming_Birthday implements IAdmin_Dashboard_Upcomming_Birthday {
    employee!: EmployeeSummaryDto;
    profileImageUrl!: string | undefined;
    birthDate!: Date | undefined;
    eventDate!: Date | undefined;
    eventDay!: string | undefined;

    constructor(data?: IAdmin_Dashboard_Upcomming_Birthday) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.profileImageUrl = _data["profileImageUrl"];
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.eventDay = _data["eventDay"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Upcomming_Birthday {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Upcomming_Birthday();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["profileImageUrl"] = this.profileImageUrl;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["eventDay"] = this.eventDay;
        return data; 
    }
}

export interface IAdmin_Dashboard_Upcomming_Birthday {
    employee: EmployeeSummaryDto;
    profileImageUrl: string | undefined;
    birthDate: Date | undefined;
    eventDate: Date | undefined;
    eventDay: string | undefined;
}

